import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
} from "@mui/material";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";
import StatusBadge from "../../../../components/common/StatusBadge";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import { Lens } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import { useSelector } from "react-redux";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import ManageReffer from "./ManageReffer";
import DeleteUser from "./DeleteUser";
import {
  getAllReferrerAction,
  setAddReferrerResponse,
  setDeleteReferrerResponse,
  updateReferrerResponse,
} from "../../../../store/reducers/referrerSlice";

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
}

const RefferList = () => {
  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  const [selectedUser, setSelectedUser] = useState("");
  const [title, setTitle] = useState("");
  const [deleteModelShow, setDeleteModelShow] = useState(false);

  const tableHeadings: TableHeading[] = [
    { label: "#", align: "left" },
    { label: "Name", align: "left" },
    { label: "Contact Name", align: "left" },
    { label: "Email", align: "left" },
    { label: "Phone No.", align: "left" },
    // { label: "Status", align: "center" },
    { label: "Action", align: "center" },
  ];

  const dispatch = useDispatch();
  const {
    referrers,
    isAddReferrerSuccess,
    isUpdateReferrerSuccess,
    pagination,
    isDeleteResponseSuccess,
  } = useSelector((state: any) => state.referrer);
  const { userProfile } = useSelector((state: any) => state?.user);
  const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
  });

  const [anchorEl, setAnchorEl] = useState(null);

  const openDown = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    dispatch(getAllReferrerAction());
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "info" }));
    };
  }, []);

  useEffect(() => {
    if (
      isAddReferrerSuccess ||
      isUpdateReferrerSuccess ||
      isDeleteResponseSuccess
    ) {
      dispatch(getAllReferrerAction());
      dispatch(setAddReferrerResponse(false));
      dispatch(updateReferrerResponse(false));
      dispatch(setDeleteReferrerResponse(false));
      setDeleteModelShow(false);
      setOpen(false);
      setSelectedUser("");
    }
  }, [isAddReferrerSuccess, isUpdateReferrerSuccess, isDeleteResponseSuccess]);

  const handleOpen = () => {
    setOpen(true);
    setTitle("Add Referrer");
  };

  const handleClose = () => {
    setOpen(false);
    setDeleteModelShow(false);
    setSelectedUser("");
    setTitle("");
    dispatch(setNotificationAction({ message: [], severity: "info" }));
    setAnchorEl(null);
  };

  const handleEditOpen = () => {
    setOpen(true);
    setAnchorEl(null);
    // setSelectedUser(user);
    setTitle("Edit Referrer");
  };

  const handleDeleteOpen = () => {
    setDeleteModelShow(true);
    setAnchorEl(null);
    // setSelectedUser(user);
    setTitle("Delete Referrer");
  };

  return (
    <>
      {deleteModelShow && (
        <DeleteUser
          selectUser={selectedUser}
          alertModalShow={deleteModelShow}
          setAlertModelShow={setDeleteModelShow}
          onHide={handleClose}
        />
      )}
      {open && (
        <ManageReffer
          selectUser={selectedUser}
          open={open}
          onHide={handleClose}
          title={title}
          isSmallScreen={false}
        />
      )}
      <PageTitle
        title="Referrer Management"
        button="Add Referrer"
        onClick={handleOpen}
      />
      <Box
        sx={{
          bgcolor: "#fff",
          // height: { xs: "auto", sm: "60vh" },
          minHeight: { xs: "auto", sm: "60vh" },
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          padding: "0px",
          overflow: "hidden",
        }}
      >
        <TableDesign
          tableHeadings={tableHeadings}
          tableHeadColor={"#02906f"}
          cellColor={"#fff"}
          pagination={referrers?.length > 0 ? pagination : null}
          isLoader={false}
          stickyHeader={true}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
          extraCSS={{
            minHeight: "calc(100%)",
            // height: "calc(100%)",
          }}
        >
          {referrers?.length > 0 ? (
            referrers?.map((val: any, idx: number) => (
              <TableRow
                key={val?.id}
                sx={{
                  cursor: "pointer",
                  marginTop: "10px",
                  padding: "4px !important",
                  borderRadius: "20px !important",
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                    outline: "2px solid #f0f0f0",
                    borderRadius: "0px !important",
                    outlineOffset: "-2px !important",
                  },
                }}
              >
                <TableCell align="left">
                  {pagination?.currentPage > 1
                    ? (pagination?.currentPage - 1) * 10 + (idx + 1)
                    : idx + 1}
                </TableCell>
                <TableCell
                  align="center"
                  style={{
                    // padding: "0px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Avatar sx={{ bgcolor: "grey.300", marginRight: 2 }} />
                  {val?.name}
                </TableCell>
                <TableCell>{val?.contact_name}</TableCell>
                <TableCell>{val?.email}</TableCell>
                <TableCell>{val?.phone}</TableCell>
                {/* <TableCell align="center">
                  <StatusBadge status={val.status} />
                </TableCell> */}
                <TableCell align="center">
                  <IconButton
                    id="basic-button"
                    aria-controls={openDown ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openDown ? "true" : undefined}
                    onClick={(e) => {
                      handleClick(e);
                      setSelectedUser(val);
                    }}
                  >
                    <MoreIcon />
                  </IconButton>
                  <Menu
                    sx={{
                      boxShadow: "none",
                      border: "2px solid #eeecef",
                      "& .MuiPaper-root": {
                        boxShadow: "none", // Removes shadow on the paper element of the menu
                        border: "2px solid #eeecef",
                      },
                      top: "0px",
                    }}
                    // className={classes.menuBox}
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={openDown}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={() => handleEditOpen()}>
                      <Lens
                        style={{
                          height: "4px",
                          width: "4px",
                          marginRight: "4px",
                        }}
                      />
                      Edit
                    </MenuItem>

                    {(userProfile?.roles?.includes("Owner") ||
                      userProfile?.roles?.includes("TENANT")) && (
                      <MenuItem onClick={() => handleDeleteOpen()}>
                        <Lens
                          style={{
                            height: "4px",
                            width: "4px",
                            marginRight: "4px",
                          }}
                        />
                        Delete
                      </MenuItem>
                    )}
                  </Menu>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5}>
                <Box
                  sx={{
                    height: "60vh",
                    display: "flex",
                    // alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      fontSize: "1rem",
                      color: "#4A4A4A",
                      top: "100px",
                    }}
                  >
                    {"No Refferer Found."}
                  </span>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Box>
    </>
  );
};

export default RefferList;
